<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden bg-card">
    <!-- Title -->
    <div
        class="flex justify-between items-center p-8 md:px-15 lg:px-30 xl:px-40 md:py-8 lg:py-8 xl:py-8"
    >
        <div class="text-4xl font-semibold tracking-tight leading-tight">
            <span class="uppercase"> PNC Central Call </span>
        </div>
    </div>
    <div
        class="flex flex-col flex-1 overflow-auto p-8 md:px-15 lg:px-30 xl:px-40"
    >
        @if(showSpinner){
        <mat-progress-spinner
            [diameter]="24"
            [mode]="'indeterminate'"
        ></mat-progress-spinner>
        }

        <!--  -->
        @if(showMessage){
        <div class="text-2xl font-semibold tracking-tight leading-tight">
            <span class="uppercase">Ruf gestartet</span>
        </div>
        }
    </div>
</div>
